module.exports = __webpack_public_path__ + "static/img/liulian.863d5a68.png";